import { render } from "./TableB.vue?vue&type=template&id=71c85d9e"
import script from "./TableB.vue?vue&type=script&lang=js"
export * from "./TableB.vue?vue&type=script&lang=js"

import "./TableB.vue?vue&type=style&index=0&id=71c85d9e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__